import { App } from 'Nbee'

export const getListenerAppName = (appData: App | null | undefined): string => {
  const id = appData?.id || 0
  if (id === 1191) return 'your webhook system'
  if (id === 1208) return 'your email system'

  return appData?.name ?? ''
}
